import React from "react";
import PolicyPage from "@/components/PolicyPage";

export default function CookiePolicy() {
  return <PolicyPage docKey="cookies" metaKey="cookies" slug="cookies" />;
}
